import { useMemo, useState } from "react";

import { queryGetBUUnassignedMember } from "@type/api/businessUnit/getBUUnassignedMember";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import {
  TGetBUUnassignedMemberReq,
  TGetBUUnassignedMemberRes,
  TUnassignedBUMember,
} from "@type/api/businessUnit/types";

interface UseGetBUUnassignedMemberProps {
  params?: TGetBUUnassignedMemberReq;
  onSuccess?: (res: TGetBUUnassignedMemberRes) => void;
}

export const useGetBUUnassignedMember = ({
  params,
  onSuccess,
}: UseGetBUUnassignedMemberProps) => {
  const [buUnassignedMembers, setBUUnassignedMembers] = useState<
    TUnassignedBUMember[]
  >([]);
  const queryGetBUUnassignedMemberKey = useMemo(() => {
    return queryGetBUUnassignedMember._key(params);
  }, [params]);

  const {
    isLoading: isLoadingGetBUUnassignedMember,
    refetch: refetchBUUnassignedMember,
  } = useQueryWithCallbacks({
    queryKey: queryGetBUUnassignedMember._key(params),
    enabled: !!params?.idBu,
    queryFn: () => queryGetBUUnassignedMember(params),
    onSuccess: (res) => {
      onSuccess?.(res);
      setBUUnassignedMembers(
        res.data.map((dt) => {
          return {
            ...dt,
            strPhoneNumber: dt?.phoneNumber
              ? `${dt?.phoneNumber?.isdCode || ""} ${dt?.phoneNumber?.number || ""}`
              : undefined,
          };
        })
      );
    },
  });

  return {
    refetchBUUnassignedMember,
    queryGetBUUnassignedMemberKey,
    buUnassignedMembers,
    isLoadingGetBUUnassignedMember,
  };
};
